import React, { ReactNode, useEffect, useRef, useState} from "react";
import GameActions from "../GameActions";

import "./PlayScreen.css";

interface Props {
    children: ReactNode;
    mainActions: ReactNode;
    additionalInfo?: ReactNode;
    showConfig: () => void;
    showInfo: () => void;
}

const PlayScreen = ({ children, mainActions, additionalInfo, showConfig, showInfo }: Props) => {
    const [isFullScreen, setIsFullScreen] = useState(false);
    const screenRef = useRef<HTMLDivElement>(null);
    const actionsRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const onFullscreenChange = () => {
            document.fullscreenElement ? setIsFullScreen(true) : setIsFullScreen(false);
        }
        document.documentElement.addEventListener('fullscreenchange', onFullscreenChange);
    }, []);
    
    useEffect(() => {
        const actionsElement = actionsRef.current;
        let timerId: NodeJS.Timeout;

        const showActions = () => {
            clearTimeout(timerId);
            actionsElement?.classList.add('show-actions-class');
            timerId = setTimeout(() => {
                actionsElement?.classList.remove('show-actions-class');   
            }, 3000);
        }
        const stopToListenMouseMove = () => {
            document.removeEventListener('mousemove', showActions);
            clearTimeout(timerId);
        }
        const listenMouseMove = () => {
            document.addEventListener('mousemove', showActions);
        }

        if (isFullScreen) {
            listenMouseMove();
            actionsElement?.addEventListener('mouseenter', stopToListenMouseMove);
            actionsElement?.addEventListener('mouseleave', listenMouseMove)
        }
        return () => {
            actionsElement?.removeEventListener('mouseenter', stopToListenMouseMove);
            actionsElement?.removeEventListener('mouseleave', listenMouseMove)
            document.removeEventListener('mousemove', showActions);
        }
    })
    
    return (
        <div ref={screenRef} className="fullscreen-element wrap-class h-full w-full mx-auto flex flex-col justify-between">
            <div className="w-full h-0"></div>
            {children}
            <div ref={actionsRef} className="actions-class items-center place-items-end flex flex-col max-lg:gap-[20px] lg:grid lg:grid-cols-3" >
                {additionalInfo && <div className="justify-self-start">{additionalInfo}</div>}
                <div className="max-lg:w-full max-lg:text-center lg:col-start-2 lg:justify-self-center">{mainActions}</div>
                <GameActions showConfig={showConfig} showInfo={showInfo} screenRef={screenRef} />
            </div>
        </div>
    )
}

export default PlayScreen;
